import SFetch from '@app/utils/sfetch'
import { SfLog } from '@app/adapters/logger'

const sortPersistControllers = { unread: null, read: null }

export default {
  getNotifications({
    companyId = Silverfin.jsonParams.company_id,
    ledgerId = null,
    search,
  }) {
    const params = {
      ...Silverfin.jsonParams,
      company_id: companyId,
      ledger_id: ledgerId,
      search,
      _options: true,
    }

    const url = Silverfin.Routes.company_inbox_index_path(params)
    return SFetch.jsonWithAlert(url)
  },
  getCompanies({ filters, unreadSort, readSort }) {
    const params = {
      ...Silverfin.jsonParams,
      note_type: filters.noteType,
      tag_ids: filters.tagIds,
      untagged: filters.untagged,
      search: filters.search,
      unread_sort: unreadSort,
      read_sort: readSort,
      _options: true,
    }

    const url = Silverfin.Routes.firm_inbox_index_path(params)

    return SFetch.jsonWithAlert(url)
  },
  async updateFirmInboxSort({ section, value }) {
    const route =
      section === 'unread'
        ? Silverfin.Routes.update_firm_inbox_unread_sort_users_path
        : Silverfin.Routes.update_firm_inbox_read_sort_users_path
    const url = route(Silverfin.currentFirmId, { value })

    sortPersistControllers[section]?.abort()
    const controller = new AbortController()
    sortPersistControllers[section] = controller

    try {
      await SFetch.json(url, { method: 'POST', signal: controller.signal })
    } catch (e) {
      if (e?.name === 'AbortError') return
      SfLog.warn('Cannot persist firm inbox sort preference', {
        extra: { error: e, section, value },
      })
    }
  },
  toggleReadNotification({ id }) {
    const params = {
      ...Silverfin.jsonParams,
      id,
      _options: true,
    }

    const url = Silverfin.Routes.toggle_read_notification_path(params)

    return SFetch.jsonWithAlert(url, { method: 'PATCH' })
  },
  fetchCompanyUnreadCount({ companyId, search }) {
    const params = {
      ...Silverfin.jsonParams,
      company_id: companyId,
      search,
      _options: true,
    }

    const url = Silverfin.Routes.unread_count_company_inbox_index_path(params)

    return SFetch.jsonWithAlert(url)
  },
}
